import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Reduced version of the management-portal's `ErrorService`: that one opens a full error
 * dialog with a "report" flow, which this internal admin tool doesn't need - a dismissible
 * snackbar is enough for the small user base of internal reviewers.
 */
@Injectable({ providedIn: 'root' })
export class ErrorService {
  private readonly _snackBar = inject(MatSnackBar);

  notify(message: string, context?: { location?: string }): void {
    if (context?.location) {
      console.error(`[Error] ${message} (${context.location})`);
    }
    this._snackBar.open(message, 'Schließen', { duration: 8000 });
  }
}
